/* eslint-disable max-lines */
import {generateFlagsContainer} from '@optimaxdev/utils';

import {UHC_COOKIE} from 'constants/uhc';

import {cookieStore} from './storage/storage';

/**
 * @public used in __specs__
 */
export type LocalFlagsType = {
    migrateDyAnalyticsD: boolean;
    dNewYearLogo: boolean;
    mHotjarTYP: boolean;
    dHotjarTYPv2: boolean;
    expNewTabFacebookM: boolean;
    checkoutTwoDayDelivery: boolean;
    checkoutInsufficientFundsOffer: boolean;
    clRebate: boolean;
    dPDPsgPackagesUI: boolean;
    isPasswordless: boolean;
    typMentionMeBanner: boolean;
    mCheckoutMFE: boolean;
    dCheckoutMFE: boolean;
    dDisableGaEc: boolean;
    dCartUI_discountColor: boolean;
    mPdp5Pack: string;
    cartTwoDayDelivery: boolean;
    checkoutPrimerCreditCard: boolean;
    DCanadaDollar: boolean;
    dReturningCustomerCL: boolean;
    hoox: boolean;
    autoApplyCouponsCLCart: boolean;
    cartSaveForLater: boolean;
    expGenderPopupD2: boolean;
    apiPopupsDY: boolean;
    dCartNextDayImp: boolean;
    pdpToCartSpa: boolean;
    clCartLearnMore: boolean;
    checkoutPrimerGooglePay: boolean;
    dCheckoutPrimerApplePay: boolean;
    checkoutPrimerPayPal: boolean;
    checkoutPrimerVenmo: boolean;
    pdpOfferRecurringCoverageV2: string;
    primerKlarna: boolean;
    mReturningCustomerCL: boolean;
    dCartShare: boolean;
    dTYPContacts: boolean;
    mGetQuoteRefactor: boolean;
    dCTPbadgesRedesign: string;
    dLuxurySpecialExperience: boolean;
    mCartGooglePay: boolean;
    mLuxurySpecialExperience: boolean;
    mPayLaterPopup: boolean;
    mCartMFE: boolean;
    mCartShare: boolean;
    dTypUI: boolean;
    dLensTintsEgCart: boolean;
    checkoutCLSoptimisation: boolean;
    mHideRewardsOffer: boolean;
    dCartUI_CouponBox: boolean;
    dCartUI_AmazonCTA: boolean;
    VistaDRdetails: boolean;
    dCheckout1step: boolean;
    mCartUI_discountColor: boolean;
    getQuoteProxy: boolean;
    stripeCheckoutMobile: boolean;
    mCheckoutPrimerApplePay: boolean;
    mKlarnaExpress: boolean;
    checkoutPrimerKlarna: boolean;
    checkoutCLConsent: boolean;
    mSubscriptionConsent: boolean;
    mCheckout1step: boolean;
    autoApplyCL: string;
    dPrimerRetryMechanism: boolean;
    dTypOneTimeCoupon: boolean;
    mPrimerRetryMechanism: boolean;
    oneSignal: boolean;
    dCheckoutCLCustomShipping: boolean;
    mCheckoutCLCustomShipping: boolean;
    dCheckoutFacelift: boolean;
    dCartAccessoriesGroups: boolean;
};

export const flags = generateFlagsContainer<LocalFlagsType>({
    apiPopupsDY: false,
    autoApplyCL: 'Control',
    autoApplyCouponsCLCart: false,
    cartSaveForLater: false,
    cartTwoDayDelivery: false,
    checkoutCLConsent: false,
    checkoutCLSoptimisation: false,
    checkoutInsufficientFundsOffer: false,
    checkoutPrimerCreditCard: false,
    checkoutPrimerGooglePay: false,
    checkoutPrimerKlarna: false,
    checkoutPrimerPayPal: false,
    checkoutPrimerVenmo: false,
    checkoutTwoDayDelivery: false,
    clCartLearnMore: false,
    clRebate: false,
    DCanadaDollar: false,
    dCartAccessoriesGroups: false,
    dCartNextDayImp: false,
    dCartShare: false,
    dCartUI_AmazonCTA: false,
    dCartUI_CouponBox: false,
    dCartUI_discountColor: false,
    dCheckout1step: false,
    dCheckoutCLCustomShipping: false,
    dCheckoutFacelift: false,
    dCheckoutMFE: false,
    dCheckoutPrimerApplePay: false,
    dCTPbadgesRedesign: 'Control',
    dDisableGaEc: false,
    dHotjarTYPv2: false,
    dLensTintsEgCart: false,
    dLuxurySpecialExperience: false,
    dNewYearLogo: false,
    dPDPsgPackagesUI: false,
    dPrimerRetryMechanism: false,
    dReturningCustomerCL: false,
    dTYPContacts: false,
    dTypOneTimeCoupon: false,
    dTypUI: false,
    expGenderPopupD2: false,
    expNewTabFacebookM: false,
    getQuoteProxy: false,
    hoox: false,
    isPasswordless: false,
    mCartGooglePay: false,
    mCartMFE: false,
    mCartShare: false,
    mCartUI_discountColor: false,
    mCheckout1step: false,
    mCheckoutCLCustomShipping: false,
    mCheckoutMFE: false,
    mCheckoutPrimerApplePay: false,
    mGetQuoteRefactor: false,
    mHideRewardsOffer: false,
    mHotjarTYP: false,
    migrateDyAnalyticsD: false,
    mKlarnaExpress: false,
    mLuxurySpecialExperience: false,
    mPayLaterPopup: false,
    mPdp5Pack: 'Control',
    mPrimerRetryMechanism: false,
    mReturningCustomerCL: false,
    mSubscriptionConsent: false,
    oneSignal: false,
    pdpOfferRecurringCoverageV2: 'Control',
    pdpToCartSpa: false,
    primerKlarna: false,
    stripeCheckoutMobile: false,
    typMentionMeBanner: false,
    VistaDRdetails: false,
});

/**
 * UHC flag
 *
 * @param {object} cookies - object that stores cookies data
 * @returns {boolean} is UHC enabled
 */
export const isUhcEnabled = (cookies: {[key: string]: string} = {}) => {
    const uhcCookie = cookies[UHC_COOKIE.KEY] || cookieStore.get(UHC_COOKIE.KEY);

    return Object.values(UHC_COOKIE.VALUES).some(
        // "${value}" cookies can contain such string
        value => value === uhcCookie || `"${value}"` === uhcCookie,
    );
};
